import { Injectable } from "@angular/core";
import { LocalDbService } from "../local-db-service";
import { Project } from "../../entities/project";

@Injectable({ providedIn: 'root' })
export class ProjectRepository {
  private get table() {
    return this.db.projectsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Project[]> {
    const rows = await this.table.toArray();
    return this.mapRows(rows);
  }

  async getAllOpenByVendorId(vendorId: number): Promise<Project[]> {
    const rows = await this.table
      .where('vendorId')
      .equals(vendorId)
      .and(project => project.isClosed === false)
      .toArray();
    return this.mapRows(rows);
  }

  async getAllOpenBySupervisorId(supervisorId: number): Promise<Project[]> {
    const rows = await this.table
      .where('supervisorId')
      .equals(supervisorId)
      .and(project => project.isClosed === false)
      .toArray();
    return this.mapRows(rows);
  }

  async getById(projectId: number): Promise<Project | undefined> {
    const row = await this.table.get(projectId);
    return row ? new Project(row) : undefined;
  }

  async getAllSupervisorIds(): Promise<number[]> {
    const rows = await this.table.toArray();

    return [...new Set(
      rows
        .map(project => project.supervisorId)
        .filter((supervisorId): supervisorId is number => supervisorId !== null && supervisorId !== undefined)
    )];
  }

  async upsertBulk(projects: Array<Project>): Promise<void> {
    if (projects.length === 0) {
      return;
    }

    const rows = projects.map(project => new Project(project));
    await this.table.bulkPut(rows);
  }

  async delete(projectId: number): Promise<void> {
    await this.table.delete(projectId);
  }

  async clear(): Promise<void> {
    await this.table.clear();
  }

  private mapRows(rows: Project[]): Project[] {
    return rows.map(row => new Project(row));
  }
}
